
export default {
  props: {
    promotion: {
      type: Object,
      default: null
    }
  },
  vessel: {
    count: {
      fontWeight: 'semibold'
    },
    image: {
      width: 'md',
      height: 'md',
      overflow: 'hidden',
      borderRadius: true,
      shadow: true,
      borderWidth: 1
    }
  },
  computed: {
    title() {
      return {
        tag: 'h2',
        html: this.promotion.name,
        fontSize: {
          all: 'xl',
          lg: '2xl'
        }
      }
    },
    text() {
      return {
        html: this.promotion.excerpt
      }
    },
    image() {
      return {
        fit: 'cover',
        ratio: { all: '16/9', lg: '4/3' },
        height: 'auto',
        borderWidth: 1,
        borderRadius: true,
        backgroundColor: 'white',
        overflow: 'hidden',
        ...this.promotion.image
      }
    },
    visibleItems() {
      return this.$screen.lg ? 5 : 3
    },
    products() {
      return this.promotion.products.slice(0, this.visibleItems)
    },
    count() {
      return this.promotion.productsCount - this.visibleItems
    },
    detailsLink() {
      const promotions = this.$pagePath('promotions')
      return `${promotions}/${this.promotion.slug}`
    }
  }
}
